import { useAtom } from "jotai";
import { connectedUserAtom } from "../../../middlewares/AuthMiddleware";

const HasRoles = ({ roles, children }) => {
  const [connectedUser] = useAtom(connectedUserAtom);
  if (!roles || !connectedUser) {
    return children;
  }
  console.log(connectedUser, roles);
  const hasRole = roles.includes(connectedUser?.role);

  return hasRole ? children : null;
};

export default HasRoles;
